import SuccessIcon from '@atlaskit/icon/core/success';
import * as React from 'react';

export function SvgCheckCircleFill() {
  return <SuccessIcon label="" testId="ads-refreshed-icon" />;
}
